import React, { useState } from "react";
import { Formik, Field } from "formik";
import validator from "validator";
import toast from "react-hot-toast";

import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";
import { Link } from "react-router-dom";

export default function Forgot() {
  const [done, setDone] = useState(false);

  const validateEmail = (value) => {
    if (!validator.isEmail(value)) {
      return "Invalid email address";
    }
  };

  if (done) {
    return (
      <div className="w-full min-h-screen px-4 py-8 bg-blue-50">
        <div className="max-w-3xl mx-auto p-8 bg-white rounded-xl shadow-lg">
          <div className="font-[Helvetica] text-center text-[32px] font-semibold	mb-[15px]">ACCOUNTING</div>
          <div className="text-[16px] text-center mb-[30px] py-0	px-[30px] text-[#555]">
            Password recovery link has been sent to your email please check you inbox and follow the link to reset your password.
          </div>
          <div className="w-full flex justify-center mt-4">
            <Link to="/auth" className="text-sky-600 hover:text-sky-700 ">
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    // Auth Wrapper
    <div className="w-full min-h-screen px-4 py-8 bg-blue-50">
      <div className="max-w-3xl mx-auto p-8 bg-white rounded-xl shadow-lg">
        <div className="font-[Helvetica] text-center text-[32px] font-semibold	mb-[15px]">ACCOUNTING</div>
        <div className="text-[16px] text-center mb-[30px] py-0	px-[30px] text-[#555]">Enter your email address below to receive the password reset link.</div>
        <Formik
          initialValues={{ email: "" }}
          onSubmit={async (values, actions) => {
            try {
              await api.post("/user/forgot_password", values);
              toast.success("Sent");
              setDone(true);
            } catch (e) {
              toast.error("Error", e.code);
            }
            actions.setSubmitting(false);
          }}>
          {({ values, errors, isSubmitting, handleChange, handleSubmit }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="mb-[25px]">
                  <div className="space-y-2">
                    <label className="text-lg font-semibold" htmlFor="email">
                      Email address
                    </label>
                    <Field
                      validate={validateEmail}
                      className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
                      name="email"
                      type="email"
                      id="email"
                      value={values.email}
                      onChange={handleChange}
                    />
                  </div>
                  <p className="text-[12px] text-[#FD3131]">{errors.email}</p>
                </div>
                <LoadingButton className="blue-btn w-full" type="submit" loading={isSubmitting}>
                  Send link
                </LoadingButton>
              </form>
            );
          }}
        </Formik>
        <div className="w-full flex items-center my-2">
          <div className="border-b border-gray-200 w-full" />
          <span className="px-2 text-gray-400 text-xs">or</span>
          <div className="border-b border-gray-200 w-full" />
        </div>
        <div className="w-full flex justify-center">
          <span className="text-black text-sm mr-1">Back to</span>
          <Link className="underline text-sm text-sky-600" to={`/auth`}>
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};
